import React, { useState } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { toast } from "sonner";
import { apiFetch } from "@/lib/api";
import { AuthShell, inputCls, labelCls, primaryBtn } from "@/components/AuthShell";

export default function ResetPassword() {
  const navigate = useNavigate();
  const location = useLocation();
  const [email, setEmail] = useState(location.state?.email || "");
  const [code, setCode] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await apiFetch("/auth/reset-password", {
        method: "POST",
        body: JSON.stringify({ email: email.trim(), code: code.trim(), new_password: newPassword }),
      });
      toast.success("Password updated — you can sign in now");
      navigate("/login");
    } catch (err) {
      toast.error(err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <AuthShell
      title="Enter reset code"
      subtitle="Check your email for the 6-digit code."
      footer={<Link to="/login" className="font-semibold text-price hover:underline">Back to sign in</Link>}
    >
      <form onSubmit={submit} className="space-y-4">
        <div>
          <label className={labelCls}>Email</label>
          <input data-testid="reset-email" type="email" required value={email} onChange={(e) => setEmail(e.target.value)} className={inputCls} />
        </div>
        <div>
          <label className={labelCls}>Reset code</label>
          <input data-testid="reset-code" required value={code} onChange={(e) => setCode(e.target.value.replace(/\D/g, ""))} maxLength={6} className={inputCls} placeholder="000000" />
        </div>
        <div>
          <label className={labelCls}>New password</label>
          <input data-testid="reset-password" type="password" required value={newPassword} onChange={(e) => setNewPassword(e.target.value)} className={inputCls} placeholder="8+ chars, letters & numbers" />
        </div>
        <button data-testid="reset-submit" type="submit" disabled={loading} className={primaryBtn}>
          {loading ? "Updating…" : "Update password"}
        </button>
      </form>
    </AuthShell>
  );
}
